import racing_flag from 'src/assets/racing_flag.png';
import green_filled_tick from 'src/assets/green_filled_tick.png';

import React, { useState, useContext, useEffect, useMemo } from 'react'
import {
  MPDayCompletionTick,
  MPDayFlagContainer,
  MPDayHeadingDateAndParticipants,
  MPDayItemEventDetailsContainer,
  MPDayItemEventParent,
  MPDayItemEventTimeContainer,
  MPDayThread,
  MPHeaderTitle,
  MPDayItemEventDetailsTitle,
  MPMobilePhaseDescription,
  MPMobilePhaseItemContainer,
  MPMobilePhaseItemTitle,
  MPPDayHeading,
  MPPDayHeadingContainer,
  MPPDayItemEventsContainer,
  MPPDayProgressConnectorContainer,
  MPPhaseDescription,
  MPPhaseImage,
  MPPhaseItemCompletedText,
  MPPhaseItemContainer,
  MPPhaseItemInfoText,
  MPPhaseItemTitle,
  MPPhaseItemTitleAndProgress,
  MPPhaseProgressContainer,
  MPPhaseProgressFilled,
  MyPlanBackground,
  MyPlanHeader,
  MyPlanPhaseDayItemContainer,
  MyPlanPhaseDetailSection,
  MyPlanPhasesSection,
  MPDayItemEventDetailsSubtitle,
  MPDayItemEventPicture,
} from './MyPlanStyles'
import { useScreenSize } from 'src/customHooks/customHooks'
import learnMeditation from 'src/assets/learnMeditation.png'
import { GenericHeaderBackButton, MyPlanHeaderCircularProgress } from './MyPlanComponents'
import { useLocation, useNavigate } from 'react-router-dom'
import { getDataForPlanDayItem, getPlanDurationText } from './myplanhelpers'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { resetPlayerData } from 'src/consumer/helpers/playerHelper'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { getDurationText } from 'src/consumer/helpers/dailyPlayHelper'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'

export default function MyPlansPage() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const screenSize = useScreenSize()
  const { setupData } = useContext(SetupContext)
  const { playerData, setPlayerData } = useContext(PlayerContext)

  const planItems = state?.cardsData?.[0]?.plan?.planItems

  useEffect(() => {
    if (!Boolean(planItems)) {
      navigate('/404')
    }
  }, [])

  const phases = [
    {
      id: 'bp',
      title: 'Build Phase',
      days: planItems?.length,
      description:
        "In these initial days, you'll embark on a journey of self-discovery and mindfulness. Start with short daily meditation sessions to establish a healthy routine. Explore the power of your breath as it guides you towards inner peace and focus. ",
      planItems: planItems,
    },
  ]
  const planCompletionProgress = useMemo(() => {
    const eachPhaseProgressArray = []
    phases?.forEach((phase) => {
      let count = 0
      phase?.planItems?.forEach((item) => {
        if (item?.status === 'completed') {
          count++
        }
      })
      eachPhaseProgressArray?.push((count / phase?.planItems?.length) * 100)
    })
    var sumOfAllProgresses = eachPhaseProgressArray.reduce((accumulator, currentValue) => {
      return accumulator + currentValue
    }, 0)
    return sumOfAllProgresses / eachPhaseProgressArray?.length
  }, [])
  const phaseCompletionProgress = (items) => {
    let count = 0
    items?.forEach((item) => {
      if (item?.status === 'completed') {
        count++
      }
    })
    return (count / items?.length) * 100
  }

  const [selectedPhaseId, setSelectedPhaseId] = useState(phases?.[0]?.id)

  return (
    <MyPlanBackground>
      <MyPlanHeader>
        <GenericHeaderBackButton />
        <MPHeaderTitle>{`Your ${getPlanDurationText(
          phases?.[0]?.planItems?.length,
        )} plan`}</MPHeaderTitle>
        {/* not right, number of days should be total of days in all phases */}
        <MyPlanHeaderCircularProgress progress={planCompletionProgress} />
      </MyPlanHeader>

      <MyPlanPhasesSection>
        {phases?.map((phaseItemData, phaseIndex) => {
          if (screenSize.width >= 980) {
            return (
              <MPPhaseItemContainer
                active={selectedPhaseId === phaseItemData?.id}
                key={phaseIndex}
                onClick={() => setSelectedPhaseId(phaseItemData?.id)}
              >
                <MPPhaseItemTitleAndProgress>
                  <div>
                    <MPPhaseItemTitle active={selectedPhaseId === phaseItemData?.id}>
                      {phaseItemData?.title}
                    </MPPhaseItemTitle>
                    <MPPhaseItemInfoText active={selectedPhaseId === phaseItemData?.id}>
                      {getPlanDurationText(phaseItemData?.days)}
                    </MPPhaseItemInfoText>
                  </div>
                  {selectedPhaseId === phaseItemData?.id ? (
                    <div>
                      <MPPhaseProgressContainer>
                        <MPPhaseProgressFilled
                          progress={phaseCompletionProgress(phaseItemData?.planItems)}
                        />
                      </MPPhaseProgressContainer>
                      <MPPhaseItemCompletedText active={selectedPhaseId === phaseItemData?.id}>
                        {`${parseInt(
                          phaseCompletionProgress(phaseItemData?.planItems),
                        )}% completed`}
                      </MPPhaseItemCompletedText>
                    </div>
                  ) : (
                    <MPPhaseItemCompletedText active={selectedPhaseId === phaseItemData?.id}>
                      {`${parseInt(phaseCompletionProgress(phaseItemData?.planItems))}% completed`}
                    </MPPhaseItemCompletedText>
                  )}
                </MPPhaseItemTitleAndProgress>
                <MPPhaseDescription active={selectedPhaseId === phaseItemData?.id}>
                  <div>{phaseItemData?.description}</div>
                  <MPPhaseImage src={learnMeditation} alt="phaseicon" />
                </MPPhaseDescription>
              </MPPhaseItemContainer>
            )
          } else {
            return (
              <MPMobilePhaseItemContainer
                active={selectedPhaseId === phaseItemData?.id}
                key={phaseIndex}
                onClick={() => setSelectedPhaseId(phaseItemData?.id)}
              >
                <MPMobilePhaseItemTitle active={selectedPhaseId === phaseItemData?.id}>
                  {phaseItemData?.title}
                </MPMobilePhaseItemTitle>
                {selectedPhaseId === phaseItemData?.id ? (
                  <div>
                    <MPPhaseProgressContainer style={{ margin: 0 }}>
                      <MPPhaseProgressFilled
                        progress={phaseCompletionProgress(phaseItemData?.planItems)}
                      />
                    </MPPhaseProgressContainer>
                    <MPPhaseItemCompletedText
                      active={selectedPhaseId === phaseItemData?.id}
                      style={{ textAlign: 'center' }}
                    >
                      {`${parseInt(phaseCompletionProgress(phaseItemData?.planItems))}% completed`}
                    </MPPhaseItemCompletedText>
                  </div>
                ) : (
                  <MPPhaseItemCompletedText
                    active={selectedPhaseId === phaseItemData?.id}
                    style={{ textAlign: 'center' }}
                  >
                    {`${parseInt(phaseCompletionProgress(phaseItemData?.planItems))}% completed`}
                  </MPPhaseItemCompletedText>
                )}
              </MPMobilePhaseItemContainer>
            )
          }
        })}
      </MyPlanPhasesSection>

      <MyPlanPhaseDetailSection>
        {screenSize.width < 980 && (
          <MPMobilePhaseDescription>
            {phases?.find((item) => item?.id === selectedPhaseId)?.description}
          </MPMobilePhaseDescription>
        )}
        {phases
          ?.find((item) => item?.id === selectedPhaseId)
          ?.planItems?.map((platItem, planItemIndex, platItemsArray) => {
            const planDataForItem = getDataForPlanDayItem(platItem, setupData)
            return (
              <MyPlanPhaseDayItemContainer key={planItemIndex}>
                <MPPDayProgressConnectorContainer>
                  <MPDayCompletionTick complete={platItem?.status === 'completed' ? true : false} />
                  <MPDayThread />
                  {planItemIndex === platItemsArray?.length - 1 && (
                    <MPDayFlagContainer>
                      <img
                        src={racing_flag}
                        style={{ width: '90%' }}
                        alt="flag"
                      />
                    </MPDayFlagContainer>
                  )}
                </MPPDayProgressConnectorContainer>

                <div style={{ width: '100%' }}>
                  <MPPDayHeadingContainer>
                    <MPPDayHeading>
                      {platItem?.status === 'completed'
                        ? `Finished Day ${platItem?.day}`
                        : `Day ${platItem?.day}`}
                    </MPPDayHeading>
                    <MPDayHeadingDateAndParticipants>
                      {/* {dayjs().format('D MMM')} */}
                    </MPDayHeadingDateAndParticipants>
                  </MPPDayHeadingContainer>

                  <MPPDayItemEventsContainer>
                    <MPDayItemEventParent
                      onClick={() => {
                        if (planDataForItem?.itemType === 'episode') {
                          setPlayerData({
                            ...resetPlayerData(playerData),
                            showPlayer: true,
                            selectedCard: playerData.showPIP
                              ? playerData?.selectedCard
                              : planDataForItem?.mainData,
                            source: 'plan',
                            id: planDataForItem?.id,
                            otherData: { planId: planDataForItem?.id },
                          })
                        }
                      }}
                    >
                      {platItem?.status === 'completed' ? (
                        <img
                          src={green_filled_tick}
                          alt="tick"
                          style={{ margin: 'auto' }}
                        />
                      ) : (
                        <div></div>
                      )}
                      <MPDayItemEventTimeContainer>11:00 AM</MPDayItemEventTimeContainer>
                      <MPDayItemEventDetailsContainer>
                        <MPDayItemEventDetailsTitle>
                          {planDataForItem?.title}
                        </MPDayItemEventDetailsTitle>
                        <MPDayItemEventDetailsSubtitle>
                          {`through ${getDurationText(planDataForItem)} ${
                            planDataForItem?.mainData?.course?.courseCategory
                          }`}
                        </MPDayItemEventDetailsSubtitle>
                        <MPDayItemEventPicture src={getImageLink(planDataForItem?.imgId)} />
                      </MPDayItemEventDetailsContainer>
                    </MPDayItemEventParent>
                  </MPPDayItemEventsContainer>
                </div>
              </MyPlanPhaseDayItemContainer>
            )
          })}
      </MyPlanPhaseDetailSection>
    </MyPlanBackground>
  )
}
